<template>
  <!-- 线索详情 -->
  <div class="clue-detail" v-loading="showLoading">
    <div class="detail-body">
      <!-- 左侧信息栏 -->
      <div v-if="showLeftContent" class="left-info">
        <div v-if="['S020', 'S030', 'S040', 'S060'].includes(stepCode)" class="info-item">
          <div class="info-value stage-title">阶段：{{ taskFilterList.filter(item => item.stepCode === stepCode).map(item => item.name).join('、') }}</div>
        </div>
        <div v-if="['S020', 'S040', 'S060'].includes(stepCode)" class="info-item">
          <div class="info-label">阶段任务</div>
          <div class="info-value">
            <div v-for="(task, idx) in taskFilterList" :key="idx" class="task-item">
              <i class="el-icon-success" :class="task.stepCode.slice(-2) < stepCode.slice(-2) ? 'task-done' : 'task-undone'"></i>
              <span class="task-name" :class="task.stepCode.slice(-2) < stepCode.slice(-2) ? '' : 'task-undone'">{{ task.name }}</span>
            </div>
          </div>
        </div>
        <div v-if="['S030'].includes(stepCode)" class="info-item">
          <div class="info-label">维护原因</div>
          <div class="info-value">{{ formData['apply_reason_formCode_' + transferFormCode] || '-' }}</div>
        </div>
        <div v-if="['S020', 'S030', 'S040', 'S060'].includes(stepCode)" class="info-item visit-status">
          <div class="info-label">拜访状态</div>
          <div class="info-value">
            <span class="visit-status-tag" :class="doctorDetailInfo.showNoVisitTag ? 'unvisited' : 'normal'">
              {{ doctorDetailInfo.showNoVisitTag
                ? (doctorDetailInfo.noVisitDays + '天未拜访')
                : '正常拜访' }}
            </span>
          </div>
        </div>
        <div v-if="['S020', 'S030', 'S040', 'S060'].includes(stepCode)" class="info-item">
          <div class="info-label">截止日期</div>
          <div class="info-value">{{ doctorDetailInfo.taskEndDate || '-' }}</div>
        </div>
        <!-- * 已签约 -->
        <div v-if="['S099'].includes(stepCode)" class="info-item">
          <div class="info-label">线索阶段</div>
          <div class="info-value">{{ taskFilterList.filter(item => item.stepCode === stepCode).map(item => item.name).join('、') }}</div>
        </div>
        <div v-if="['S099'].includes(stepCode)" class="info-item">
          <div class="info-label">审批人</div>
          <div class="info-value">{{ doctorDetailInfo.auditerNameText }}</div>
        </div>
        <div v-if="['S099'].includes(stepCode)" class="info-item">
          <div class="info-label">签约日期</div>
          <div class="info-value">{{ doctorDetailInfo.signDate || '-' }}</div>
        </div>
        <!-- 暂时先注释，后期要放开 -->
        <!-- <div v-if="['S099'].includes(stepCode)" class="info-item">
          <div class="info-label">签约周期</div>
          <div class="info-value">{{ doctorDetailInfo.signDays || '-' }}天</div>
        </div> -->
        <div class="info-item">
          <div class="info-label">跟进小组</div>
          <div class="info-value">{{ doctorDetailInfo.groupName || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">跟进人</div>
          <div class="info-value">{{ doctorDetailInfo.workName || '-' }}</div>
        </div>
      </div>

      <!-- 右侧主内容区 -->
      <div class="right-content" :class="{'no-left-content': !showLeftContent}">
        <!-- 医生头部信息卡片 -->
        <div class="doctor-header-wrap">
          <div class="doctor-header-card" :class="{ 'is-key-point': doctorDetailInfo.isImportant }">
            <!-- 重点突破标记 -->
            <span v-if="doctorDetailInfo.isImportant" class="key-point-tag">重点突破</span>
            <div class="doctor-avatar">
              <img :src="avatar" alt="头像" />
            </div>
            <div class="doctor-header-info">
              <div class="doctor-name-row">
                <div class="doctor-name-row-content">
                  <span class="doctor-name">{{ formData['doctor_name_formCode_' + baseInfoFormCode] || '-' }}</span>
                  <span
                    v-if="formData['aa_formCode_' + baseInfoFormCode] && formData['aa_formCode_' + baseInfoFormCode].length > 0"
                    class="doctor-title"
                  >
                    / {{ (formData['aa_formCode_' + baseInfoFormCode] || []).map(item => item.questionItemLabel).join('、') }}
                  </span>
                  <span class="doctor-age">{{ formData['age_formCode_' + baseInfoFormCode] || '-' }}岁</span>
                </div>
                <CustomStarText iconSize="18px" :saleStar="doctorDetailInfo.saleStar" :avgStar="doctorDetailInfo.avgStar" />
              </div>
              <div class="doctor-tags">
                <el-tag
                  v-for="(tag, idx) in formData['ab_formCode_' + baseInfoFormCode]"
                  :key="idx"
                  size="small"
                  effect="plain"
                  type="warning"
                >{{ tag.questionItemLabel }}</el-tag>
              </div>
              <div class="doctor-metrics">
                <span>月销售额 <b>{{ doctorDetailInfo.monthSale || '-' }}万</b></span>
                <span class="metric-divider">|</span>
                <span>
                  次均门诊量 <b>{{ doctorDetailInfo.avgVisitNum || '-' }}人</b>
                  <span
                    v-if="doctorDetailInfo.newCustomRatio !== undefined && doctorDetailInfo.newCustomRatio !== null && doctorDetailInfo.newCustomRatio !== ''"
                    class="new-custom-tag"
                  >新客{{ ((doctorDetailInfo.newCustomRatio || 0) * 100).toFixed(1) }}%</span>
                </span>
                <span class="metric-divider">|</span>
                <span>坐诊诊室 <b>{{ seePatientList.length || '-' }}家</b></span>
              </div>
            </div>
          </div>
          <!-- 标记重点 -->
          <span
            v-if="(
              !doctorDetailInfo.isImportant
              && (
                roleType === 1
                || (roleType === 2 && groupInfoId === doctorDetailInfo.groupInfoId)
                || (roleType === 3 && workNumber === doctorDetailInfo.workNumber)
              )
            )
            && ['S020', 'S040', 'S060'].includes(stepCode)"
            class="key-point-btn is-mark"
            @click="toggleKeyPointHandle"
          >标记重点</span>
          <!-- 取消标记 -->
          <span
            v-if="(
              doctorDetailInfo.isImportant
              && (
                roleType === 1 || (roleType === 2 && groupInfoId === doctorDetailInfo.groupInfoId)
              )
            )
            && ['S020', 'S040', 'S060'].includes(stepCode)"
            class="key-point-btn is-cancel"
            @click="toggleKeyPointHandle"
          >取消标记</span>
        </div>

        <!-- 医生期望 -->
        <div v-if="stepCode !== 'S099'" class="doctor-expect">
          <div class="expect-title">医生期望</div>
          <div class="expect-row">
            <span class="expect-item">挂号费 <b>{{ formData['register_price_formCode_' + doctorWishFormCode] || '-' }}元</b></span>
            <span class="expect-divider">|</span>
            <span class="expect-item">挂号提成 <b>{{ formData['register_commission_formCode_' + doctorWishFormCode] || '-' }}%</b></span>
            <span class="expect-divider">|</span>
            <span class="expect-item">药费提成 <b>{{ formData['drug_commission_formCode_' + doctorWishFormCode] || '-' }}%</b></span>
            <span class="expect-divider">|</span>
            <span class="expect-item">外治提成 <b>{{ formData['physio_commission_formCode_' + doctorWishFormCode] || '-' }}%</b></span>
          </div>
          <div class="expect-row">
            <span class="expect-item">储备区域 <b>{{ (formData['reserve_area_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</b></span>
            <span class="expect-divider">|</span>
            <span class="expect-item">意向医馆 <b>{{ (formData['practice_hospital_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</b></span>
            <span class="expect-divider">|</span>
            <span class="expect-item">坐诊时间 <b>{{ (formData['practice_time_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</b></span>
          </div>
          <div class="expect-row need-row">
            <span class="expect-label">自带患者能力</span>
            <span class="need-text">{{ (formData['patient_acquisition_capacity_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</span>
          </div>
          <div class="expect-row need-row">
            <span class="expect-label">预计到馆时间</span>
            <span class="need-text">{{ formData['estimated_arrival_date_formCode_' + doctorWishFormCode] || '-' }}</span>
          </div>
          <div class="expect-row need-row">
            <span class="expect-label">预计合作属性</span>
            <span class="need-text">{{ (formData['expected_cooperation_type_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</span>
          </div>
          <div class="expect-row need-row">
            <span class="expect-label">医生需求</span>
            <span class="need-text" :class="{ collapsed: !needExpanded }" ref="needTextRef">{{ formData['expectation_formCode_' + doctorFeedbackFormCode] || '-' }}</span>
            <span class="need-toggle" v-show="showNeedToggle" @click="needExpanded = !needExpanded">
              {{ needExpanded ? '收起' : '展开' }} <i :class="needExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </span>
          </div>
        </div>

        <!-- 标签页 -->
        <el-tabs v-model="activeTab" class="detail-tabs">
          <el-tab-pane label="个人资料" name="profile">
          </el-tab-pane>
          <el-tab-pane label="坐诊信息" name="seePatient">
          </el-tab-pane>
          <el-tab-pane v-if="stepCode === 'S099'" label="医生期望" name="doctorWish">
          </el-tab-pane>
          <el-tab-pane v-if="stepCode === 'S099'" label="签约信息" name="signInfo">
          </el-tab-pane>
          <el-tab-pane label="推进记录" name="progressRecord">
          </el-tab-pane>
        </el-tabs>
        <div class="detail-content" :style="{ height: stepCode === 'S099' ? '400px' : '300px' }">
          <!-- 个人资料 -->
          <div v-show="activeTab === 'profile'" class="profile-info">
            <!-- 基本信息 -->
            <div class="info-block">
              <div class="block-title">基本信息</div>
              <div class="block-content">
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">姓名</span>
                    {{ formData['doctor_name_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">性别</span>
                    {{
                      formData['sex_formCode_' + baseInfoFormCode]
                      && formData['sex_formCode_' + baseInfoFormCode][0]
                      && formData['sex_formCode_' + baseInfoFormCode][0].questionItemLabel
                      || '-'
                    }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">年龄</span>
                    {{ formData['age_formCode_' + baseInfoFormCode] || '-' }}岁
                  </span>
                </div>
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">出生日期</span>
                    {{ formData['birth_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">籍贯</span>
                    {{ (formData['province_native_place_name_formCode_' + baseInfoFormCode] + formData['city_native_place_name_formCode_' + baseInfoFormCode]) || '-' }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">手机号码</span>
                    {{ formData['phone_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                </div>
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">微信号</span>
                    {{ formData['wxid_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">毕业院校</span>
                    {{ formData['school_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- 工作信息 -->
            <div class="info-block">
              <div class="block-title">工作信息</div>
              <div class="block-content">
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">职称</span>
                    {{
                      (formData['aa_formCode_' + baseInfoFormCode] && formData['aa_formCode_' + baseInfoFormCode][0]
                        ? formData['aa_formCode_' + baseInfoFormCode][0].questionItemLabel
                        : '-')
                      }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">师承</span>
                    {{ formData['inherit_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">荣誉称号</span>
                    {{ (formData['ab_formCode_' + baseInfoFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                  </span>
                </div>
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">月收入</span>
                    {{
                      (formData['income_month_amount_formCode_' + baseInfoFormCode]
                      && formData['income_month_amount_formCode_' + baseInfoFormCode][0]
                      && formData['income_month_amount_formCode_' + baseInfoFormCode][0].questionItemLabel)
                      || '-'
                    }}
                  </span>
                  <span class="info-row-item">
                    <span class="row-label">治疗方式</span>
                    <el-tag
                      v-for="item in formData['physio_type_formCode_' + baseInfoFormCode]"
                      :key="item.questionItemValue"
                      size="mini"
                      :type="item.questionItemValue === '1' ? 'primary' : 'success'"
                      class="treat-tag"
                    >{{ item.questionItemLabel }}
                    </el-tag>
                  </span>
                  <span v-if="showPhysioRate" class="info-row-item">
                    <span class="row-label">外治占比</span>
                    {{ formData['physio_rate_formCode_' + baseInfoFormCode] || '-' }}%
                  </span>
                </div>
                <div class="info-row grid3">
                  <span class="info-row-item">
                    <span class="row-label">介绍人</span>
                    {{ formData['referrer_formCode_' + baseInfoFormCode] || '-' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- 辅助信息 -->
            <div class="info-block">
              <div class="block-title">辅助信息</div>
              <div class="block-content">
                <div class="info-row">
                  <span class="info-row-item">
                    <span class="row-label">婚姻状况</span>
                    {{
                      (formData['is_marry_formCode_' + assistanceFormCode]
                      && formData['is_marry_formCode_' + assistanceFormCode][0]
                      && formData['is_marry_formCode_' + assistanceFormCode][0].questionItemLabel)
                      || '-'
                    }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-row-item">
                    <span class="row-label">子女情况</span>
                    {{ formData['children_formCode_' + assistanceFormCode] || '-' }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-row-item">
                    <span class="row-label">家庭住址</span>
                    {{ formData['address_formCode_' + assistanceFormCode] || '-' }}
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-row-item">
                    <span class="row-label">爱好</span>
                    {{ formData['interest_formCode_' + assistanceFormCode] || '-' }}
                  </span>
                </div>
                <div v-if="formData['sensitive_topic_formCode_' + assistanceFormCode]" class="info-row taboo-row">
                  <i class="el-icon-warning taboo-icon"></i>
                  <span class="taboo-label">禁忌话题</span>
                  <span class="taboo-value">{{ formData['sensitive_topic_formCode_' + assistanceFormCode] }}</span>
                </div>
                <div v-else class="info-row">
                  <span class="info-row-item">
                    <span class="row-label">禁忌话题</span>
                    -
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 坐诊信息 -->
          <div v-show="activeTab === 'seePatient'" class="see-patient-info">
            <!-- 坐诊医院列表 -->
            <div class="clinic-list">
              <div v-for="(item, index) in seePatientList" :key="index" class="clinic-card">
                <!-- 医院头部 -->
                <div class="clinic-header">
                  <div class="hospital-info">
                    <i class="el-icon-office-building hospital-icon"></i>
                    <span class="hospital-name">{{ item['hospital_formCode_' + seePatientFormCode] || '-' }}</span>
                  </div>
                  <div class="hospital-tags">
                    <span
                      v-if="item['establishment_formCode_' + seePatientFormCode] && item['establishment_formCode_' + seePatientFormCode][0] && item['establishment_formCode_' + seePatientFormCode][0].questionItemValue === '1'"
                      class="tag tag-compilation"
                    >有编制</span>
                    <!-- <span class="tag tag-treatment" :class="'type-' + clinic.treatmentType">{{ clinic.treatmentTypeText }}</span> -->
                  </div>
                </div>

                <!-- 医院地址和时间 -->
                <div class="clinic-detail">
                  <div class="detail-row">
                    <i class="el-icon-location-outline"></i>
                    <span>
                      {{ item['hospital_address_formCode_' + seePatientFormCode] || '-' }}
                    </span>
                  </div>
                  <div class="detail-row">
                    <i class="el-icon-time"></i>
                    <span>{{ (item['practice_time_formCode_' + seePatientFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</span>
                  </div>
                </div>

                <!-- 接诊科室 -->
                <div class="see-patient-title">接诊科室</div>
                <div class="clinic-detail">
                  <span class="see-patient-department">
                    {{ item['department_formCode_' + seePatientFormCode] || '-' }}
                  </span>
                </div>

                <!-- 经营数据 -->
                <div class="see-patient-title">经营数据</div>
                <div class="clinic-metrics">
                  <div class="metric-item">
                    <span class="metric-label">月度销售额</span>
                    <span class="metric-value">{{ item['sales_month_amount_formCode_' + seePatientFormCode] || '-' }}万</span>
                  </div>
                  <div class="metric-item">
                    <span class="metric-label">次均门诊量</span>
                    <span class="metric-value">{{ item['outpatient_service_day_number_formCode_' + seePatientFormCode] || '-' }}人</span>
                  </div>
                  <div v-if="item['new_customer_day_number_formCode_' + seePatientFormCode]" class="metric-item">
                    <span class="metric-label">次均新客</span>
                    <span class="metric-value">{{ item['new_customer_day_number_formCode_' + seePatientFormCode] || '-' }}人</span>
                  </div>
                  <div class="metric-item">
                    <span class="metric-label">挂号费</span>
                    <span class="metric-value">{{ item['register_price_formCode_' + seePatientFormCode] || '-' }}元</span>
                  </div>
                  <!-- <div class="metric-item">
                    <span class="metric-label">提前挂号率</span>
                    <span class="metric-value">{{ item['register_advance_rate_formCode_' + seePatientFormCode] || '-' }}%</span>
                  </div> -->
                  <div class="metric-item">
                    <span class="metric-label">满号时间</span>
                    <span class="metric-value">{{ ((item['fully_booked_time_formCode_' + seePatientFormCode] || [])[0] || {}).questionItemLabel || '-' }}</span>
                  </div>
                  <div class="metric-item">
                    <span class="metric-label">挂号提成</span>
                    <span class="metric-value">{{ item['register_commission_formCode_' + seePatientFormCode] || '-' }}%</span>
                  </div>
                  <div class="metric-item">
                    <span class="metric-label">药费提成</span>
                    <span class="metric-value">{{ item['drug_commission_formCode_' + seePatientFormCode] || '-' }}%</span>
                  </div>
                </div>

                <!-- 简介与擅长 -->
                <div class="see-patient-title">简介与擅长</div>
                <div class="clinic-content">
                  <div class="clinic-detail">
                    <span class="see-patient-synopsis-title">简介：</span>
                    <span class="see-patient-synopsis">
                      {{ item['synopsis_formCode_' + seePatientFormCode] || '-' }}
                    </span>
                  </div>
                  <div class="clinic-detail">
                    <span class="see-patient-virtue-title">擅长：</span>
                    <span class="see-patient-virtue">
                      {{ item['virtue_formCode_' + seePatientFormCode] || '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="seePatientList.length === 0" class="empty">暂无坐诊信息</div>
          </div>
          <!-- 医生期望 -->
           <div v-show="activeTab === 'doctorWish'" class="doctor-wish">
            <div class="doctor-wish-content">
              <div class="info-block">
                <div class="block-content">
                  <div class="info-row grid4">
                    <span class="info-row-item">
                      <span class="row-label">挂号费</span>
                      {{ formData['register_price_formCode_' + doctorWishFormCode] || '-' }}元
                    </span>
                    <span class="info-row-item">
                      <span class="row-label">挂号提成</span>
                      {{ formData['register_commission_formCode_' + doctorWishFormCode] || '-' }}%
                    </span>
                    <span class="info-row-item">
                      <span class="row-label">药费提成</span>
                      {{ formData['drug_commission_formCode_' + doctorWishFormCode] || '-' }}%
                    </span>
                    <span class="info-row-item">
                      <span class="row-label">外治提成</span>
                      {{ formData['physio_commission_formCode_' + doctorWishFormCode] || '-' }}%
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">储备区域</span>
                      {{ (formData['reserve_area_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">意向医馆</span>
                      {{ (formData['practice_hospital_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">坐诊时间</span>
                      {{ (formData['practice_time_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label large-row-label">自带患者能力</span>
                      {{ (formData['patient_acquisition_capacity_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label large-row-label">预计到馆时间</span>
                      {{ formData['estimated_arrival_date_formCode_' + doctorWishFormCode] || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label large-row-label">预计合作属性</span>
                      {{ (formData['expected_cooperation_type_formCode_' + doctorWishFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">医生需求</span>
                      {{ formData['expectation_formCode_' + doctorFeedbackFormCode] || '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
           </div>
          <!-- 签约信息 -->
          <div v-show="activeTab === 'signInfo'" class="sign-info">
            <div class="sign-info-tabs">
              <span class="tab-item" :class="{ active: signActiveTab === 'basic' }" @click="signActiveTab='basic'">基本信息</span>
              <span class="tab-item" :class="{ active: signActiveTab === 'paper' }" @click="signActiveTab='paper'">证件信息</span>
              <span class="tab-item" :class="{ active: signActiveTab === 'operation' }" @click="signActiveTab='operation'">运营信息</span>
              <span class="tab-item" :class="{ active: signActiveTab === 'seePatient' }" @click="signActiveTab='seePatient'">坐诊信息</span>
              <span class="tab-item" :class="{ active: signActiveTab === 'material' }" @click="signActiveTab='material'">物料信息</span>
              <span class="tab-item" :class="{ active: signActiveTab === 'other' }" @click="signActiveTab='other'">其他信息</span>
            </div>
            <div class="sign-info-content">
              <!-- 基本信息 -->
              <div v-show="signActiveTab === 'basic'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">科室</span>
                      {{ formData['department_formCode_' + signFormCode] || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">第一坐诊点</span>
                      {{ (formData['first_hospital_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">简介</span>
                      {{ formData['synopsis_formCode_' + signFormCode] || '-' }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item">
                      <span class="row-label">擅长</span>
                      {{ formData['virtue_formCode_' + signFormCode] || '-' }}
                    </span>
                  </div>
                  <!-- 图片字段 -->
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">医生个人形象照</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['individuation_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['individuation_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['individuation_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无医生个人形象照图片</div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 证件信息 -->
              <div v-show="signActiveTab === 'paper'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">执业证书</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['a1_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['a1_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['a1_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无执业证书图片</div>
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">资格证书</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['a2_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['a2_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['a2_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无资格证书图片</div>
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">职称证</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['a3_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['a3_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['a3_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无职称证图片</div>
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">身份证</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['id_card_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['id_card_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['id_card_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无身份证图片</div>
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">身份证号</span>
                      <div class="row-value">
                        {{ formData['id_card_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">银行卡</span>
                      <div class="image-list">
                        <el-image
                          v-for="(img, idx) in formData['bank_card_image_formCode_' + signFormCode]"
                          :key="idx"
                          :src="img"
                          :preview-src-list="formData['bank_card_image_formCode_' + signFormCode]"
                          class="info-image"
                          fit="cover"
                        />
                        <div v-if="(formData['bank_card_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无银行卡图片</div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 运营信息 -->
              <div v-show="signActiveTab === 'operation'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">医生类型</span>
                      <div class="row-value">
                        {{ (formData['doctor_type_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">是否接受医馆回访患者</span>
                      <div class="row-value">
                        {{ (formData['is_allow_visit_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">医生自运营模式</span>
                      <div class="row-value">
                        <div v-for="(item, index) in (formData['operation_model_formCode_' + signFormCode] || [])" :key="index">
                          {{ item.questionItemLabel }}
                        </div>
                        <div v-if="(formData['operation_model_formCode_' + signFormCode] || []).length === 0">-</div>
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">自媒体账号所有权</span>
                      <div class="row-value">
                        {{ (formData['account_owner_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">目前微信累计添加患者数</span>
                      <div class="row-value">
                        {{ formData['sum_patient_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">是否自带患者</span>
                      <div class="row-value">
                        {{ (formData['is_patient_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">自带患者的方法</span>
                      <div class="row-value">
                        {{ (formData['in_patient_way_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">运营策略</span>
                      <div class="row-value">
                        {{ (formData['operation_profile_new_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 坐诊信息 -->
              <div v-show="signActiveTab === 'seePatient'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">首次坐诊日期</span>
                      <div class="row-value">
                        {{ formData['first_date_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">叫号规则</span>
                      <div class="row-value">
                        {{ (formData['call_rule_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">放号规则</span>
                      <div class="row-value">
                        {{ formData['create_rule_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">挂号费</span>
                      <div class="row-value">
                        {{ formData['register_price_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">加号费</span>
                      <div class="row-value">
                        {{ formData['add_register_price_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">坐诊时间和坐诊分馆</span>
                      <div class="row-value">
                        {{ formData['practice_time_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">到馆后每周坐诊次数</span>
                      <div class="row-value">
                        {{ formData['practice_count_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 物料要求 -->
              <div v-show="signActiveTab === 'material'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">物料制作需求</span>
                      <div class="row-value">
                        <div v-for="(item, index) in (formData['materiel_require_formCode_' + signFormCode] || [])" :key="index">
                          {{ item.questionItemLabel }}
                        </div>
                        <div v-if="(formData['materiel_require_formCode_' + signFormCode] || []).length === 0">-</div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 其他事项 -->
              <div v-show="signActiveTab === 'other'" class="info-block">
                <div class="block-content">
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">医生其他需求</span>
                      <div class="row-value">
                        {{ formData['other_info_formCode_' + signFormCode] || '-' }}
                      </div>
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-row-item block">
                      <span class="row-label">引进到馆审批确定人</span>
                      <div class="row-value">
                        {{ (formData['auditer_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 推进记录 -->
          <div v-show="activeTab === 'progressRecord'" class="progress-record">
            <div class="progress-record-list">
              <div
                v-for="(item, index) in (doctorDetailInfo.followList || [])"
                :key="index"
                class="record-item"
                :class="{ 'is-last': index === (doctorDetailInfo.followList || []).length - 1 }"
                @click="showOrHideRecordDetailHandle($event, item)"
              >
                <!-- 左侧时间线 -->
                <div class="record-rail">
                  <div class="record-dot"></div>
                  <div v-if="index !== (doctorDetailInfo.followList || []).length - 1" class="record-line"></div>
                </div>

                <!-- 右侧内容 -->
                <div class="record-content">
                  <div class="record-info">
                    <span class="record-type">
                      {{
                        item.isVisit 
                        ? item.visitTypeText
                        : (
                            (['S030', 'S040', 'S060'].includes(item.stepCode) && item.stepCode === stepCode && item.taskIndex === 0)
                            ? ('已进入' + followRecordPageInfo[item.stepCode].name + '阶段')
                            : (
                                item.isCreate
                                ? followRecordPageInfo[item.stepCode].name
                                : (item.stepCode === 'S000' ? followRecordPageInfo[item.stepCode].publicSeaName : followRecordPageInfo[item.stepCode].name)
                              )
                          )
                      }}
                      {{ item.remark && item.stepCode === 'S099'? ('(' + item.remark + ')') : ''}}
                    </span>
                    <span class="record-time">{{ item.createDateTime }}</span>
                    <span class="record-operator">{{ item.creatorName }}</span>
                    <i v-if="(item.taskIndex && item.taskIndex !== 0 && (item.stepCode === 'S030' || item.stepCode === 'S040' || item.stepCode === 'S050' || item.stepCode === 'S060')) || item.isVisit" class="el-icon-arrow-right record-arrow"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty" v-if="(doctorDetailInfo.followList || []).length === 0">暂无推进记录</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 转入公海/长期维护/换跟进人/继续跟进 -->
    <CustomModal
      v-model="modalInfo.showModal"
      :title="modalInfo.titleInfo[modalInfo.modalType]"
      width="600px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      submitBtnText="确定"
      cancelBtnText="取消"
      :modalContentNoPadding="true"
      @submitHandle="transferOrChangeClueFormConfirmHandle"
      @cancelHandle="showOrHideModalHandle"
    >
      <TransferOrChangeClueForm
        v-if="modalInfo.showModal"
        ref="transferOrChangeClueFormRef"
        :instanceId="instanceId"
        :doctorId="doctorId"
        :stepCode="stepCode"
        :stepId="stepId"
        :modalType="modalInfo.modalType"
      />
    </CustomModal>

    <!-- 推进记录详情 -->
    <CustomModal
      v-model="modalInfo.showRecordDetailModal"
      :title="modalInfo.titleInfo[modalInfo.modalType]"
      width="600px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideRecordDetailHandle($event)"
    >
      <VisitDetail
        v-if="modalInfo.modalType === 'showVisitDetail'"
        ref="visitDetailRef"
        :currentRecordInfo="modalInfo.currentRecordInfo"
        :modalType="modalInfo.modalType"
      />
      <TransferLongTimeDetail
        v-if="modalInfo.modalType === 'showTransferLongTimeDetail'"
        ref="transferLongTimeDetailRef"
        :currentRecordInfo="modalInfo.currentRecordInfo"
        :modalType="modalInfo.modalType"
      />
      <InvitationDetail
        v-if="modalInfo.modalType === 'showInvitationDetail'"
        ref="invitationDetailRef"
        :currentRecordInfo="modalInfo.currentRecordInfo"
        :modalType="modalInfo.modalType"
      />
      <LeaderCoVisitDetail
        v-if="modalInfo.modalType === 'showLeaderCooperationDetail'"
        ref="leaderCoVisitDetailRef"
        :currentRecordInfo="modalInfo.currentRecordInfo"
        :modalType="modalInfo.modalType"
      />
      <PromoteContractDetail
        v-if="modalInfo.modalType === 'showPromoteContractDetail'"
        ref="promoteContractDetailRef"
        :currentRecordInfo="modalInfo.currentRecordInfo"
        :modalType="modalInfo.modalType"
      />
    </CustomModal>
  </div>
</template>

<script>
import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const baseInfoFormCode = 'FR100'
const seePatientFormCode = 'FR103'
const assistanceFormCode = 'FR101'
const doctorWishFormCode = 'FR102'
const doctorFeedbackFormCode = 'FR013'
const transferFormCode = 'FR006'
const signFormCode = 'FR012'

const taskList = [
  { name: '信息采集', stepCode: 'S020' },
  { name: '长期维护', stepCode: 'S030' },
  { name: '邀约参观', stepCode: 'S040' },
  { name: '推进签约', stepCode: 'S060' },
  { name: '已签约', stepCode: 'S099' }
]

// 推进记录跳转页面详情地址信息
const followRecordPageInfo = {
  // 拜访医生
  visit: {
    name: '拜访医生',
    modalName: 'showVisitDetail'
  },
  // 创建线索
  'S000': {
    name: '创建线索',
    publicSeaName: '领取线索'
  },
  // 信息采集
  // 'S020': {
  //   name: '信息采集',
  //   path: '/doctorVisit/clue/doTask/doTask'
  // },
  // 转长期维护
  'S030': {
    name: '转长期维护',
    modalName: 'showTransferLongTimeDetail'
  },
  // 邀约参观
  'S040': {
    name: '邀约参观',
    modalName: 'showInvitationDetail'
  },
  // 领导协访
  'S050': {
    name: '领导协访',
    modalName: 'showLeaderCooperationDetail'
  },
  // 推进签约
  'S060': {
    name: '推进签约',
    modalName: 'showPromoteContractDetail'
  },
  // 流程结束
  'S099': {
    name: '流程结束'
  }
}
export default {
  name: 'ClueDetail',
  data() {
    return {
      showLoading: false,
      stepCode: '',
      stepId: '',
      taskList,
      activeTab: 'profile',
      signActiveTab: 'basic',
      needExpanded: false,
      showNeedToggle: false, // 是否显示展开/收起按钮
      baseInfoFormCode,
      seePatientFormCode,
      assistanceFormCode,
      doctorWishFormCode,
      doctorFeedbackFormCode,
      transferFormCode,
      signFormCode,
      doctorDetailInfo: {},
      formData: {},
      seePatientList: [],
      originOptionsInfo: {},
      showPhysioRate: false,
      followRecordPageInfo,
      modalInfo: {
        modalType: '', // 弹窗类型(showPublicsea/showLongTime/showChangeFollower/showContinueFollow/showVisitDetail/showTransferLongTimeDetail/showInvitationDetail/showPromoteContractDetail)
        showModal: false, // 显示弹窗
        showRecordDetailModal: false, // 显示记录详情弹窗
        currentRecordInfo: {}, // 当前记录信息
        titleInfo: {
          showPublicsea: '转入公海',
          showLongTime: '转长期维护',
          showChangeFollower: '换跟进人',
          showContinueFollow: '再次推进',
          showVisitDetail: '拜访详情',
          showTransferLongTimeDetail: '转长期维护详情',
          showInvitationDetail: '邀约参观详情',
          showLeaderCooperationDetail: '领导协访详情',
          showPromoteContractDetail: '推进签约详情'
        },
      },
    }
  },
  methods: {
    async init() {
      this.showLoading = true
      try {
        await this.getClueDetail()
        const currentFlowStepFormCodeList = [baseInfoFormCode, seePatientFormCode, assistanceFormCode, doctorWishFormCode, doctorFeedbackFormCode]
        if (this.stepCode === 'S030') currentFlowStepFormCodeList.push(transferFormCode)
        if (this.stepCode === 'S099') currentFlowStepFormCodeList.push(signFormCode)
        if (currentFlowStepFormCodeList.length > 0) {
          await this.getFormFieldList(currentFlowStepFormCodeList)
          await this.getFormData(currentFlowStepFormCodeList)
        }
        // 数据加载完成后检测文本是否溢出
        this.$nextTick(() => {
          this.checkNeedTextOverflow()
        })
      } catch (error) {
        console.error('初始化线索详情页面数据失败', error)
      } finally {
        this.showLoading = false
      }
    },

    // 切换重点标记（后续可在此处接入标记/取消标记接口）
    async toggleKeyPointHandle() {
      const confirm = await utils.messageBoxConfirm({
        title: '操作提示',
        message: this.doctorDetailInfo.isImportant
                 ? `确认取消${this.formData['doctor_name_formCode_' + baseInfoFormCode] || '-'}的重点突破标记？`
                 : `确认将${this.formData['doctor_name_formCode_' + baseInfoFormCode] || '-'}标记为重点突破医生？` ,
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      })
      if (!confirm) return
      const params = {
        flowInstanceId: this.instanceId,
        followAction: this.stepCode,
        formData: [
          {
            formCode: 'FR018',
            fieldData: [
              {
                formFieldCode: 'FR01801',
                value: this.doctorDetailInfo.isImportant ? ['0'] : ['1']
              },
              {
                formFieldCode: 'FR01802',
                value: this.doctorId ? [this.doctorId] : []
              }
            ]
          }
        ],
        stepCode: this.stepCode,
        stepId: this.stepId
      }
      try {
        const res = await formFlow.submitFormData(params)
        if (res.code === 200) {
          this.$message.success('操作成功！')
          this.init()
        }
      } catch (error) {
        console.log('标记/取消标记重点医生失败', error)
      }
    },
  
    // 检测医生需求文本是否超出一行
    checkNeedTextOverflow() {
      this.$nextTick(() => {
        const needTextEl = this.$refs.needTextRef
        if (needTextEl) {
          // 比较 scrollHeight 和 clientHeight 判断是否溢出
          const isOverflow = needTextEl.scrollHeight > needTextEl.clientHeight ||  needTextEl.scrollWidth > needTextEl.clientWidth
          this.showNeedToggle = isOverflow
        }
      })
    },

    // 获取第一坐诊点的options
    async getFirstHospitalFormList() {
      const dataList = await formFlow.getFormData({
        instanceId: this.instanceId,
        stepCode: this.stepCode,
        stepId: this.stepId,
        formCode: seePatientFormCode,
        doctorId: this.doctorId,
        dataType: 'list'
      })
      return dataList.map((item, index) => {
        return {
          sort: index,
          value: (item.formData['doctor_practice_id_formCode_' + seePatientFormCode] || {}).value[0] || '',
          label: (item.formData['hospital_formCode_' + seePatientFormCode] || {}).value[0] || '',
          questionItemValue: (item.formData['doctor_practice_id_formCode_' + seePatientFormCode] || {}).value[0] || '',
          questionItemLabel: (item.formData['hospital_formCode_' + seePatientFormCode] || {}).value[0] || ''
        }
      })
    },

    // 通过表单id获取表单字段
    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormInfo,
        fieldList,
        showFormFieldKeyInfo,
        originOptionsInfo,
        optionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      const firstHospitalOptions = await this.getFirstHospitalFormList()
      this.formData = formData
      this.originOptionsInfo = {
        ...originOptionsInfo,
        ['first_hospital_formCode_' + signFormCode]: firstHospitalOptions
      }
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData, seePatientList } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.instanceId,
          stepCode: this.stepCode,
          stepId: this.stepId,
          formCode,
          doctorId: this.doctorId,
          dataType: formCode === seePatientFormCode ? 'list' : 'obj'
        })
        // console.log('获取详情页面表单页面数据', data)

        // 表单获取的数据为空，则初始化表单id
        if (formCode === seePatientFormCode) {
          const fieldList = Object.keys(formData).filter(item => item.endsWith('_formCode_' + seePatientFormCode))
          data.forEach(el => {
            const seePatientItem = {}
            for(const field of fieldList) {
              const item = el.formData[field] || {}
              const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
              if ([1, 2].includes(item.inputType)) {
                // 单选/多选
                seePatientItem[field] = (this.originOptionsInfo[field] || []).filter(item => valueList.includes(item.questionItemValue))
              } else {
                seePatientItem[field] = valueList[0] || ''
              }
            }
            seePatientList.push(seePatientItem)
          })
        } else {
          for(const key in data.formData) {
            const item = data.formData[key] || {}
            const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
            if ([
              'individuation_image_formCode_' + signFormCode, // 执业证书
              'a1_image_formCode_' + signFormCode, // 执业证书
              'a2_image_formCode_' + signFormCode, // 资格证书
              'a3_image_formCode_' + signFormCode, // 职称证
              'id_card_image_formCode_' + signFormCode, // 身份证
              'bank_card_image_formCode_' + signFormCode, // 银行卡
            ].includes(key)) {
              // 图片
              const pictureList = valueList
              formData[key] = pictureList.map(item => this.imageBaseUrl + item)
            } else {
              if ([1, 2].includes(item.inputType)) {
                // 单选/多选
                formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
              } else {
                formData[key] = valueList[0] || formData[key] || ''
              }
            }
          }
        }
        this.formData = formData
        this.seePatientList = seePatientList
        this.showPhysioRate = formData['physio_type_formCode_' + baseInfoFormCode].some(item => item.questionItemValue === '2')
      }
    },

    // 获取详情信息
    async getClueDetail() {
      const params = {
        // ...this.hasReceivedTask === '1' && {
          doctorStageId: this.instanceId || '',
        // },
        doctorId: this.doctorId || ''
      }
      try {
        const res = await request.get('/cluepool/pc/doctor/queryDoctorExtend', params, '')
        if (res.code === 200) {
          const data = res.data || {}
          
          const visitTypeInfo = {
            '1': '坐诊点拜访',
            '2': '微信拜访',
            '3': '电话拜访',
            '4': '家访',
            '5': '宴请',
            '6': '跟诊'
          }

          // 推进记录列表
          let followList = [
            ...(data.followRecords || []).map((item, index) => ({
              ...item,
              taskIndex: index
            })),
            ...(data.visits || []).map(item => ({
              ...item,
              isVisit: true,
              visitTypeText: visitTypeInfo[item.visitType] || ''
            }))
          ]
          .filter(item => !!followRecordPageInfo[item.stepCode] || item.isVisit)
          .sort((a, b) => b.createTime - a.createTime)

          // 添加isCreate字段（是否是创建线索）
          followList = followList.map((item, index) => ({
            ...item,
            createDateTime: item.createTime ? new Date(item.createTime).Format('yyyy-MM-dd hh:mm:ss') : '',
            isCreate: item.stepCode === 'S000' && followList.findLastIndex(ite => ite.stepCode === 'S000') === index
          }))

          this.doctorDetailInfo = {
            ...data,
            followList,
            signDate: data.signTime ? new Date(data.signTime).Format('yyyy-MM-dd') : '',
            taskEndDate: data.taskEndTime ? new Date(data.taskEndTime).Format('yyyy-MM-dd') : '',
            auditerNameText: utils.getDataType(data.auditerName) === 'array' ? data.auditerName.join('、') : (data.auditerName || ''),
            avatarImageUrl: data.individualuationImage ? (data.individualuationImage.split(',')[0] || '') : '',
          }
          if (this.currentStepCode) {
            // 外部传入的stepCode
            this.stepCode = this.currentStepCode
          } else {
            this.stepCode = res.data.currentStepCode || ''  
          }
          this.stepId = res.data.currentStepId || ''
        } else {
          this.$message.error(res.message || '获取线索详情失败')
        }
      } catch (error) {
        console.log('获取线索详情失败', error)
      }
    },
    
    // 转入公海/长期维护/换跟进人/继续跟进弹窗确认
    async transferOrChangeClueFormConfirmHandle() {
      const isSubmitSuccess = await this.$refs.transferOrChangeClueFormRef.submitHandle()
      if (isSubmitSuccess) {
        this.showOrHideModalHandle()
        await this.getClueDetail()
        this.$emit('updateCurrentClueInfoHandle', { stepCode: this.stepCode, stepId: this.stepId })
      }
    },

    // 转线索/长期维护/换跟进人/继续跟进弹窗显示隐藏
    showOrHideModalHandle(modalName) {
      if (!modalName) {
        this.modalInfo.showModal = false
        this.modalInfo.modalType = ''
        return
      }
      this.modalInfo.showModal = !this.modalInfo.showModal
      this.modalInfo.modalType = this.modalInfo.showModal ? modalName : ''
    },

    // 显示隐藏推进记录详情
    showOrHideRecordDetailHandle(event, itemInfo) {
      let modalName = ''
      if (itemInfo) {
        // 不可点击的跟进记录
        if (!this.showRecordArr(itemInfo)) return
        this.modalInfo.currentRecordInfo = itemInfo
        // 如果是正在进行中的任务，则不允许查看
        if (itemInfo.taskIndex === 0) return
        if (itemInfo.isVisit || (followRecordPageInfo[itemInfo.stepCode] && followRecordPageInfo[itemInfo.stepCode].modalName)) {
          if (itemInfo.isVisit) {
            modalName = followRecordPageInfo.visit.modalName
          } else {
            modalName = followRecordPageInfo[itemInfo.stepCode].modalName
          }
        }
      }
      this.modalInfo.showRecordDetailModal = !this.modalInfo.showRecordDetailModal
      this.modalInfo.modalType = this.modalInfo.showRecordDetailModal ? modalName : ''
    },
  },
  props: {
    instanceId: {
      type: String,
      default: ''
    },
    doctorId: {
      type: String,
      default: ''
    },
    // 登录人角色
    roleType: {
      type: Number,
      default: 0
    },
    // 登录人所属小组id
    groupInfoId: {
      type: String,
      default: ''
    },
    // 登录人工号
    workNumber: {
      type: Number,
      default: 0
    },
    // 当前步骤码，默认为空，如果此字段传进来的有值，则不取queryDoctorExtend接口中返回的值
    currentStepCode: {
      type: String,
      default: ''
    },
    showLeftContent: {
      type: Boolean,
      default: true
    },
    // 是否领取了公海任务，1表示领取了任务（非公海线索，默认已领取），0表示没有领取任务
    hasReceivedTask: {
      type: String,
      default: '1'
    }
  },
  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
    },
    defaultImageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://www.xinglinct.com' : 'https://test.xinglinct.com'
    },
    avatar() {
      // 判断有没有上传图片，如果有则显示上传的，否则显示默认的
      if (this.doctorDetailInfo.avatarImageUrl) {
        return this.imageBaseUrl + this.doctorDetailInfo.avatarImageUrl
      } else {
        const avatarUrl = this.defaultImageBaseUrl + '/employee_tools_weapp/images/'
        const avatarInfo = {
          '1': 'male.png',
          '2': 'females.png',
          '3': 'defaultAvatar.png'
        }
        if (this.formData['sex_formCode_' + baseInfoFormCode] && this.formData['sex_formCode_' + baseInfoFormCode][0]) {
          return avatarUrl + avatarInfo[(this.formData['sex_formCode_' + baseInfoFormCode][0] || {}).questionItemValue || '3']
        } else {
          return avatarUrl + 'defaultAvatar.png'
        }
      }
    },
    taskFilterList() {
      if (['S030', 'S099'].includes(this.stepCode)) {
        return this.taskList.filter(item => item.stepCode === this.stepCode)
      } else {
        const resultTaskList = []
        const taskList = this.taskList.filter(item => !['S030', 'S099'].includes(item.stepCode))
        const taskIndex = taskList.findIndex(item => item.stepCode === this.stepCode)
        taskList.forEach((el, index) => {
          if (index <= taskIndex) { 
            resultTaskList.push(el)
          }
        })
        return resultTaskList
      }
    },
    showRecordArr() {
      return (itemInfo) => (itemInfo.taskIndex && itemInfo.taskIndex !== 0 && (itemInfo.stepCode === 'S030' || itemInfo.stepCode === 'S040' || itemInfo.stepCode === 'S050' || itemInfo.stepCode === 'S060')) || itemInfo.isVisit
    }
  },
  mounted() {
    this.init()
  },
  components: {
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    CustomFormItem: () => import('@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'),
    TransferOrChangeClueForm: () => import('./TransferOrChangeClueForm.vue'),
    VisitDetail: () => import('./recordDetail/VisitDetail.vue'),
    TransferLongTimeDetail: () => import('./recordDetail/TransferLongTimeDetail.vue'),
    InvitationDetail: () => import('./recordDetail/InvitationDetail.vue'),
    LeaderCoVisitDetail: () => import('./recordDetail/LeaderCoVisitDetail.vue'),
    PromoteContractDetail: () => import('./recordDetail/PromoteContractDetail.vue'),
  }
}
</script>

<style scoped lang="less">
.clue-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.detail-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

// 左侧信息栏
.left-info {
  width: 200px;
  flex-shrink: 0;
  border-right: 1px solid #E8E8E8;
  padding: 20px 16px;
  box-sizing: border-box;
  overflow-y: auto;

  .info-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
    line-height: 1.5;

    &.visit-status {
      align-items: center;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      width: 70px;
      white-space: nowrap;
      font-size: 13px;
      color: #9AA0A8;
    }

    .info-value {
      width: calc(100% - 70px);
      font-size: 13px;
      color: #1F2329;
      // text-align: justify;
      font-weight: 500;

      &.stage-title {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .task-item {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 8px;
      font-size: 13px;
      color: #1F2329;

      &:last-child {
        margin-bottom: 0;
      }

      .task-name {
        font-size: 13px !important;
        color: #1F2329;
      }

      .task-done {
        color: #1890FF;
        font-size: 14px;
      }

      .task-undone {
        color: #A4AFBA;
        font-size: 14px;
      }
    }

    .visit-status-tag {
      display: inline-block;
      padding: 3px 6px 4px;
      border-radius: 2px;
      font-size: 12px;

      &.normal {
        background-color: #E2F8E0;
        color: #29C01B;
      }

      &.unvisited {
        background-color: #FFF0E1;
        color: #FE8F1F;
      }

      &.overdue {
        background-color: #FFF0E1;
        color: #F54A45;
      }
    }
  }
}

// 右侧主内容区
.right-content {
  flex: 1;
  min-width: 0;
  margin-left: 10px;
  padding-right: 20px;
  box-sizing: border-box;
  overflow-y: auto;

  &.no-left-content {
    margin-left: 16px;
  }
}

// 医生头部信息区（卡片 + 标记按钮）
.doctor-header-wrap {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 0 16px;

  // 标记重点 / 取消标记 按钮
  .key-point-btn {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 16px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 1;
    border-radius: 16px;
    background-color: #FFF;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s;

    &.is-mark {
      color: #1890FF;
      border: 1px solid #1890FF;

      &:hover {
        color: #40A9FF;
        border-color: #40A9FF;
        background-color: #F0F8FF;
      }
    }

    &.is-cancel {
      color: #667182;
      border: 1px solid #D9D9D9;

      &:hover {
        color: #1890FF;
        border-color: #1890FF;
      }
    }
  }
}

// 医生头部信息卡片
.doctor-header-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 500px;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #FFF8E1;
  border-radius: 8px;
  padding: 16px;

  // 重点突破 标签
  .key-point-tag {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    line-height: 22px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
    color: #E84026;
    background-color: #FFDBDB;
    border-radius: 8px 0 8px 0;
    white-space: nowrap;
  }

  // 已标记重点时，内容整体下移，避免与标签重叠
  &.is-key-point {
    padding-top: 28px;
  }

  .doctor-avatar {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    background-color: #E8E8E8;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .doctor-header-info {
    flex: 1;
    min-width: 0;

    .doctor-name-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;

      .doctor-name {
        font-size: 16px;
        font-weight: 600;
        color: #1F2329;
      }

      .doctor-age {
        margin-left: 8px;
        font-size: 14px;
        color: #667182;
      }

      .doctor-title {
        font-size: 14px;
        color: #667182;
      }
    }

    .doctor-tags {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      margin-bottom: 10px;

      /deep/ .el-tag--plain.el-tag--warning {
        background-color: #FFE7BE;
        border-color: #F1E4BD;
        color: #805A1B;
      }
    }

    .doctor-metrics {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 13px;
      color: #667182;

      b {
        color: #1F2329;
        font-weight: 500;
      }

      // 新客占比标记
      .new-custom-tag {
        display: inline-flex;
        align-items: center;
        height: 18px;
        padding: 0 6px;
        margin-left: 6px;
        font-size: 12px;
        line-height: 1;
        color: #1677FF;
        background-color: #DFF0FF;
        border-radius: 17px;
        vertical-align: middle;
        white-space: nowrap;
      }

      .metric-divider {
        color: #D3D3D5;
      }
    }
  }
}

// 医生期望
.doctor-expect {
  margin-bottom: 16px;

  .expect-title {
    font-size: 14px;
    font-weight: 600;
    color: #1F2329;
    margin-bottom: 10px;
  }

  .expect-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 0;
    margin-bottom: 8px;
    font-size: 13px;
    color: #667182;

    &:last-child {
      margin-bottom: 0;
    }

    .expect-item {
      b {
        color: #1F2329;
        font-weight: 500;
      }
    }

    .expect-divider {
      color: #D3D3D5;
      margin: 0 10px;
    }
  }

  .need-row {
    align-items: flex-start;

    .expect-label {
      margin-top: 3px;
      color: #667182;
      flex-shrink: 0;
    }

    .need-text {
      flex: 1;
      color: #1F2329;
      margin-left: 6px;
      line-height: 20px;
      word-break: break-all;

      &.collapsed {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .need-toggle {
      color: #1890FF;
      cursor: pointer;
      flex-shrink: 0;
      margin-left: 6px;
      padding-top: 2px;
      font-size: 13px;

      i {
        font-size: 12px;
      }

      &:hover {
        color: #40A9FF;
      }
    }
  }
}

// 标签页
.detail-tabs {
  /deep/ .el-tabs__header {
    margin-left: 0;
    margin-bottom: 16px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #E8E8E8;
  }

  /deep/ .el-tabs__item {
    font-size: 14px;
    color: #667182;

    &.is-active {
      color: #1890FF;
      font-weight: 500;
    }
  }

  /deep/ .el-tabs__active-bar {
    background-color: #1890FF;
  }
}

.detail-content {
  margin-top: 6px;
  padding-right: 10px;

  .detail-title {
    padding: 12px 0px;
    font-size: 16px;
    font-weight: 600;
    color: #1F2329;
  }

  .block-title {
    font-size: 14px;
    font-weight: 600;
    color: #1F2329;
    margin-bottom: 10px;
  }

  // 默认信息块
  .block-content {
    margin-top: 6px;
    .info-row {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 10px;
      font-size: 13px;
      color: #1F2329;

      &:last-child {
        margin-bottom: 12px;
      }

      &.grid3 {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
      }

      &.grid4 {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
      }

      .info-row-item {
        display: inline-flex;
        align-items: flex-start;
        gap: 4px;

        &.block {
          display: block;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
        }

        .row-label {
          flex-shrink: 0;
          width: 56px;
          color: #9AA0A8;

          &.large-row-label {
            width: 86px;
          }
        }

        .row-value {
          margin-top: 8px;
          line-height: 1.5;
        }

        .image-list {
          display: flex;
          flex-wrap: wrap;
          margin-top: 8px;
          gap: 4px;

          /deep/ .el-image__inner.el-image__preview {
            width: 80px;
            height: 80px;
            object-fit: cover;
          }
        }

        /deep/ .treat-tag {
          margin-right: 4px;
          transform: translateY(-3px);
        }
      }
    }

    .taboo-row {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-top: 8px;
      padding: 6px 10px;
      background-color: #FFF5F5;
      border-radius: 4px;
      width: fit-content;

      .taboo-icon {
        color: #F54A45;
        font-size: 14px;
      }

      .taboo-label {
        color: #F54A45;
        font-size: 13px;
        font-weight: 500;
      }

      .taboo-value {
        color: #F54A45;
        font-size: 13px;
      }
    }
  }

  // 坐诊信息
  .see-patient-info {
    .clinic-list {
      .clinic-card {
        background-color: #FFF;
        border-radius: 8px;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        // 医院头部
        .clinic-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 8px;

          .hospital-info {
            display: flex;
            align-items: center;
            gap: 8px;

            .hospital-icon {
              font-size: 16px;
              color: #1890FF;
            }

            .hospital-name {
              font-size: 14px;
              font-weight: 600;
              color: #1F2329;
            }
          }

          .hospital-tags {
            display: flex;
            gap: 8px;

            .tag {
              padding: 0 10px;
              font-size: 13px;
              line-height: 23px !important;
              height: 24px !important;
              border-radius: 4px;

              &.tag-compilation {
                background-color: #FFF3D6;
                color: #FAAD14;
              }

              &.tag-treatment {
                &.type-internal {
                  background-color: #E6F4FF;
                  color: #1890FF;
                }

                &.type-external {
                  background-color: #E2F8E0;
                  color: #29C01B;
                }

                &.type-both {
                  background-color: #F0E8FF;
                  color: #722ED1;
                }
              }
            }
          }
        }

        // 医院地址和时间
        .clinic-detail {
          margin-bottom: 16px;

          .detail-row {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 8px;
            font-size: 13px;
            color: #667182;

            &:last-child {
              margin-bottom: 0;
            }

            i {
              font-size: 14px;
              color: #9AA0A8;
            }
          }
        }

        // 标题
        .see-patient-title {
          font-size: 14px;
          font-weight: 600;
          color: #1F2329;
          margin-bottom: 10px;
        }

        // 科室
        .see-patient-department {
          display: inline-block;
          font-size: 13px;
          color: #098B5E;
          padding: 4px 12px 6px;
          background: #E6FFED;
          border-radius: 18px;
        }

        // 经营数据
        .clinic-metrics {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 16px;

          .metric-item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 32px;
            background-color: #F7F8F9;
            border-radius: 20px;
            font-size: 13px;

            .metric-label {
              color: #667182;
            }

            .metric-value {
              color: #1F2329;
              font-weight: 600;
              margin-left: 4px;
            }
          }
        }

        // 简介与擅长
        .clinic-content {
          margin-bottom: 16px;
          padding: 8px 10px;
          border-radius: 8px;
          font-size: 12px;
          color: #323233;
          line-height: 1.5;
          background-color: #F7F8FA;

          .clinic-detail {
            margin-bottom: 6px;
            .see-patient-synopsis-title,
            .see-patient-virtue-title {
              font-weight: 600;
              color: #1F2329;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }

  // 签约信息
  .sign-info {
    margin-top: 6px;
    .sign-info-tabs {
      display: inline-flex;
      margin-bottom: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      overflow: hidden;

      .tab-item {
        padding: 6px 8px;
        border-right: 1px solid #e0e0e0;
        cursor: pointer;

        &:last-child {
          border-right: none;
        }

        &.active {
          background-color: #1890FF;
          color: #FFF;
        }
      }
    }

    .row-label {
      width: 72px !important;
    }
  }
  
  // 推进记录
  .progress-record {
    .progress-record-list {
      padding-bottom: 20px;
      box-sizing: border-box;
      .record-item {
        display: flex;
        align-items: stretch;
        position: relative;

        &.is-last .record-content {
          padding-bottom: 0;
        }

        // 左侧时间线
        .record-rail {
          width: 20px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 4px;
          position: relative;

          .record-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #D9D9D9;
            border: 2px solid #FFF;
            box-shadow: 0 0 0 2px #D9D9D9;
            flex-shrink: 0;
            z-index: 2;
          }

          .record-line {
            flex: 1;
            width: 1px;
            background-color: #E8E8E8;
            margin-top: 4px;
            border-left: 1px dashed #D9D9D9;
            background-color: transparent;
          }
        }

        // 右侧内容
        .record-content {
          flex: 1;
          min-width: 0;
          padding-bottom: 16px;

          .record-info {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-left: 8px;
            font-size: 14px;
            line-height: 1.5;
            color: #73747C;
            cursor: pointer;

            .record-type {
              flex-shrink: 0;
              font-weight: 500;
            }

            .record-time {
              color: #9AA0A8;
              flex-shrink: 0;
            }

            .record-operator {
              flex-shrink: 0;
            }
          }
        }
      }
    }
  }

  .empty {
    color: #9AA0A8;
    font-size: 13px;
    line-height: 1.5;
  }
}

// 底部按钮
/deep/ .el-tabs {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  .el-tabs__header {
    padding-left: 0;
  }
}
</style>